<template>
  <div>
    <div class="p-6 cursor-pointer w-full md:w-1/2 mx-auto">
      <span class="flex text-zt-dark-400"
        @click="$router.push({ name: 'pendingApproval', params: { showPendingProp: 2, routerGo: 'dashboard' } })"
        data-vs-button="toPendingApproval">
        <zt-icon name="angle-left" class="pb-2 mt-1 pr-1" />
        <p>{{ $t("message.licenseComponent.licenseBox.back") }}</p>
      </span>
      <h1 class="fnot-italic font-normal text-zt-xl leading-8 flex items-center text-zt-primary-200 pb-6">{{
        $t("message.menuComponent.licences.loadLicense") }}</h1>
      <div class="bg-white border border-gray-300 rounded hover:shadow-xl px-16 pt-16 w-full">
        <vue-loading background-color="rgba(0,0,0,0.0)" :active="loadingLicence" color="#4F41A3" :width="30"
          :height="30" :is-full-page="false" />
        <div class="flex text-zt-primary-600 pb-4 text-lg">
          <p class="text-2xl font-bold mb-8">{{ $t('message.loadLicence.title') }}</p>
        </div>
        <div v-if="postResponseMessage !== ''" :class="errorClass" class="
            alert-company
            border
            rounded
            border-0
            flex
            py-6
            px-4
            mb-6
          ">
          <div class=" ml-1 mr-4 ml-4 w-4">
            <zt-icon :name="errorIcon" :class="errorIcon" class="info-icon" />
          </div>
          <p class="text-zt-base font-normal self-center">
            {{ postResponseMessage }}
          </p>
        </div>
        <div class="mb-2 ">
          <p class="text-xl font-medium mb-6">
            {{
              $t(
                "message.loadLicence.licenceColaborator"
              )
            }}
          </p>
          <p class="text-sm w-11/12 text-zt-dark-300 py-4">
            {{
              $t(
                "message.loadLicence.colaboratorDescription"
              )
            }}
          </p>
          <v-autocomplete solo :label="$t('message.dashboard.colaboratorLabel')" :items="licenceColaborators"
            :loading="isLoading" v-model="licenceUser" :search-input.sync="search" :value="licenceUser.id"
            @change="getLicenceData" cache-items hide-no-data hide-selected item-text="name" item-value="id"
            return-object data-vs-autocomplete="approver"></v-autocomplete>
        </div>
        <div class="my-2">
          <p class="text-xl font-medium mb-6">
            {{
              $t(
                "message.loadLicence.licenceType"
              )
            }}
          </p>
          <p class="text-sm w-11/12 text-zt-dark-300 py-4">
            {{
              $t(
                "message.loadLicence.typeDescription"
              )
            }}
          </p>
          <v-autocomplete solo :label="$t('message.dashboard.licenseTypeLabel')" :items="licenceType"
            :disabled="!licenceUser.id && loadingLicence" v-model="licenceTypeSelected" item-text="name"
            @change="checkAllowsSalaryPaymentAdvance" item-value="id" return-object></v-autocomplete>
        </div>
        <div class="mb-4 ">
          <p class="text-xl font-medium mb-6">
            {{
              $t(
                "message.loadLicence.dateRange"
              )
            }}
          </p>
          <p class="text-sm w-11/12 text-zt-dark-300 py-4">
            {{
              $t(
                "message.loadLicence.dateRangeDescription"
              )
            }}
          </p>
          <div v-if="isCollaboratorSelected">
            <vc-date-picker class="mx-auto" :value="dateRange" mode="range" color="indigo" :attributes="holidays"  
              data-vs-datepicker="datesRange" @input="dateSelected($event)" ref="datepicker" />
            <VDatePicker is-range>
              <template #default="{ inputValue, inputEvents }">
                <div class="flex justify-center items-center py-2">
                  <BaseInput :value="inputValue.start" v-on="inputEvents.start" />
                  <IconArrowRight />
                  <BaseInput :value="inputValue.end" v-on="inputEvents.end" />
                </div>
              </template>
            </VDatePicker>
            <div class="flex justify-between p-2">
              <div @click="modalSichernPeopleInfo = true" class=" text-sm"
                v-if="showVacacionesDetails">
                {{
                    $tc(
                      'message.inicioComponent.licensesAvailable',
                      saldo
                    )
                  }}
              </div>
              <div @click="modalSichernPeopleInfo = true" class=" text-sm text-zt-primary-200 underline  cursor-pointer"
                v-if="showVacacionesDetails">
                {{ $t('message.dashboard.salaryAdvance.seeDetail') }}
              </div>
            </div>
          </div>
          <div v-else >
             <v-autocomplete solo :label="$t('message.dashboard.salaryAdvance.expectedDate')" :items="licenceType"
            v-model="licenceTypeSelected" item-text="name"
            @change="checkAllowsSalaryPaymentAdvance" item-value="id" return-object disabled></v-autocomplete>
          </div>
          <v-checkbox data-vs-check-box="select-document" v-model="salaryPaymentAdvance" color="primary" :value="1"
            :label="$t('message.licenseComponent.licenseBox.registerAnticipatePayment')"
            v-if="allowsSalaryPaymentAdvance" />
        </div>
        <div class="footer p-10 flex justify-end">
          <zt-button class="cancel-button text-base font-bold" text
            @click="$router.push({ name: 'pendingApproval', params: { showPendingProp: 2, routerGo: 'dashboard' } })"
            data-vs-button="toPendingApproval">{{
              $t("message.loadLicence.btnCancel")
            }}</zt-button>
          <zt-button class="text-base font-bold ml-2" @click="postLicence" :disabled="!isFormValid || isSubmitting">{{
            $t("message.loadLicence.btnLoad")
            }}</zt-button>
        </div>
      </div>
    </div>
     <zt-modal
      :active="modalSichernPeopleInfo"
      @close="modalSichernPeopleInfo = false"
      id="sichernPeopleInfo"
      max-width="80rem"
      :fullscreen="isMobile"
    >
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <span>{{
            $t('message.licenseComponent.licenseBox.sichernPeopleInfo')
          }}</span>
        </div>
      </template>
      <div class="px-4 pb-4">
        <div class="sichern-people-table">
          <div class="table-container">
            <HolidaysBalanceTable
              :saldo="saldo"
              :details="sichernPeopleDetailsData"
            />
          </div>
        </div>
      </div>
    </zt-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import VCalendar from 'v-calendar'
import Manager from "@/apiClient/Manager"
import Licenses from "@/apiClient/Licenses"
import HolidaysBalanceTable from '@/modules/Licenses/components/request/HolidaysBalanceTable.vue'
import SichernIntegration from '@/apiClient/SichernIntegration'

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  firstDayOfWeek: 2,
  masks: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    input: ['DD/MM/YYYY'],
    data: ['DD/MM/YYYY']
  }
})


export default {
   components: {
    HolidaysBalanceTable
  },
  data() {
    return {
      manager: Manager,
      documentsData: {},
      licenses: {},
      isSubmitting: false,
      licenceMessage: '',
      postResponseMessage: '',
      licenceType: [],
      licenceTypeSelected: '',
      licenceDates: '17/08/2023 - 25/08/2023',
      licenceDate: '17/08/2023 - 25/08/2023',
      holidays: [],
      range: {},
      entries: [],
      isLoading: false,
      loadingLicence: false,
      allowsSalaryPaymentAdvance: false,
      salaryPaymentAdvance: false,
      licenceUser: {
        id: '',
        nombre: '',
        apellido: '',
        name: '',
        usuario: ''
      },
      search: null,
       modalSichernPeopleInfo: false,
      sichernPeopleDetailsData: null,
      detailsBySubtype: '',
      saldo: 0,
      showVacacionesDetails: false,
    }
  },
  async created() {
    this.manager = new Manager
    this.licenses = new Licenses();
    this.vi = new SichernIntegration()
    await this.getLicenceHolidays()
    await this.getLicenceData()
    this.$refs.datepicker.$children[0].$el.placeholder = this.$t("message.HeaderComponent.timePeriod")
  },
  computed: {
    licenceColaborators() {
      return this.entries.map(entry => {
        let fullName = `${entry.name} (${entry.cuil})`;
        const name =
          fullName.length > this.descriptionLimit
            ? fullName.slice(0, this.descriptionLimit) + "..."
            : fullName;

        return Object.assign({}, entry, { name });
      });
    },
    errorClass() {
      switch (this.licenceMessage) {
        case 'info':
          return 'bg-certs-info';
        case 'error':
          return 'bg-certs-error';
        case 'warning':
          return 'bg-certs-warning';
        default:
          return 'no-errors';
      }
    },
    errorIcon() {
      switch (this.licenceMessage) {
        case 'info':
          return 'info';
        case 'error':
          return 'exclamation-circle-solid';
        case 'warning':
          return 'warning-triangle-solid';
        default:
          return 'default-message';
      }
    },
    dateRange() {
      const dateParts = this.licenceDates.split(' - ');
      if (dateParts.length === 2) {
        const startDate = this.convertToDate(dateParts[0]);
        const endDate = this.convertToDate(dateParts[1]);
        return [startDate, endDate];
      }
      return [];
    },
    isFormValid() {
      return this.licenceTypeSelected && this.search && this.range.hasOwnProperty('start') && this.range.hasOwnProperty('end');
    },
    isCollaboratorSelected() {
    return this.licenceUser.id && Object.keys(this.licenceUser).length > 0;
  },
  },
  methods: {
    async getLicenceData(selectedUser) {
      if (selectedUser.id) {
        this.loadingLicence = true
        this.licenceType = []
        this.licenceTypeSelected = ''
        this.postResponseMessage = ''
        this.licenceMessage = ''
        try {
          const response = await this.manager.getLicenceTypes(selectedUser.id)
          this.licenceType = response.data.data
          await this.getLicenceHolidays();
          this.loadingLicence = false
        }
        catch (error) {
          this.postResponseMessage = this.$t("message.HeaderComponent.failedAgain")
          this.licenceMessage = 'error'
        }
      }
    },
    async getLicenceHolidays() {
      if (!this.licenceUser.id) {
      this.holidays = [];
      return;
    }

    try {
        const holidays = (await this.manager.getLicenceHolidays(this.licenceUser.id)).data.data;

        this.holidays = holidays.map(value => {
          const { id, date, policy, company, description } = value;
          const color = policy !== null && policy !== 0 ? 'green' : company !== null && company !== 0 ? 'blue' : 'red';
          const currentDate = new Date(date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'));
          const nextDate = new Date(currentDate);
          nextDate.setDate(currentDate.getDate() + 1);

          return {
            key: id,
            dates: nextDate,
            dot: { color },
            popover: { label: description }
          };
        });
      } catch (error) {
        this.holidays = []
      }
    },
    setInitialDateRange() {
      let dateFrom = new Date(moment(this.state.request.fechaDesde, 'DD/MM/YYYY').format('YYYY-MM-DD'))
      let dateTo = new Date(moment(this.state.request.fechaReingreso, 'DD/MM/YYYY').format('YYYY-MM-DD'))
      dateFrom.setDate(dateFrom.getDate() + 1)
      dateTo.setDate(dateTo.getDate() + 1)
      this.range = {
        start: dateFrom,
        end: dateTo
      }
    },
    async checkAllowsSalaryPaymentAdvance() {
      this.salaryPaymentAdvance = false
      this.allowsSalaryPaymentAdvance = false
      const response = await this.manager.allowsSalaryPaymentAdvance(this.licenceTypeSelected.id)
      this.allowsSalaryPaymentAdvance = response.data.data.allowsSalaryPaymentAdvance
      this.selectType()
    },
    async selectType(){
 this.showVacacionesDetails = false
      this.sichernPeopleDetailsData = null
      this.saldo = 0
      
      if (this.licenceTypeSelected.alias !== 'Vacaciones') {
        return
      }

      try {
        const [balanceResponse, saldoResponse] = await Promise.all([
          this.vi.getDetailedBalances({ id: this.licenceUser.id }),
          this.licenses.getBalanceByTypes({ id: this.licenceUser.id, typeId: this.licenceTypeSelected.id })
        ])

        const balanceDetails = balanceResponse.data.results.data
        this.sichernPeopleDetailsData = balanceDetails || []
        this.previewDaysVP =
          balanceDetails.balanceOfPeriods &&
          balanceDetails.balanceOfPeriods.length > 0 &&
          balanceDetails.balanceOfPeriods[0].previewDays
            ? balanceDetails.balanceOfPeriods[0].previewDays
            : 0

        this.saldo = saldoResponse.data.results.data[0].available || 0
        this.showVacacionesDetails = true
      } catch (error) {
        this.sichernPeopleDetailsData = null
        this.saldo = 0
      }
    },
    dateSelected(range) {
      if (range) {
        this.postResponseMessage = "";
        this.licenceMessage = ''
        this.range = {
          start: moment(range.start).format("DD/MM/YYYY"),
          end: moment(range.end).format("DD/MM/YYYY")
        }
        if (range.start && range.end && range.start.toDateString() === range.end.toDateString()) {
          // Si las fechas son iguales, no permitir la selección
          this.postResponseMessage = this.$t("message.HeaderComponent.dates")
          this.licenceMessage = 'error'
          this.range = {};
        }
      }
    },
    async postLicence() {
      if (this.isSubmitting) {
        return;
      }

      this.postResponseMessage = "";
      this.isSubmitting = true;
      try {
        const data = {
          dateFrom: moment(this.range.start, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          dateTo: moment(this.range.end, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          licenceTypeId: this.licenceTypeSelected.id,
          userId: this.licenceUser.id,
          anticipatePayment: this.salaryPaymentAdvance
        };
        const { dateFrom, dateTo, licenceTypeId, userId, anticipatePayment } = data

        // Realizar una solicitud POST con los datos al servidor
        const postResponse = await this.manager.postManagerLicence(dateFrom, dateTo, licenceTypeId, userId, anticipatePayment)
        this.range = {}
        this.$refs.datepicker.$children[0].$el.placeholder = this.$t("message.HeaderComponent.timePeriod")
        this.licenceDates = ""
        this.licenceTypeSelected = ''
        this.licenceUser = {}
        this.salaryPaymentAdvance = false
        this.allowsSalaryPaymentAdvance = false
        this.licenceMessage = 'info' //ver bien como llega la data para mostrar o no el mensaje y si es warning error info 
        this.postResponseMessage = this.$t("message.HeaderComponent.success")
      } catch (error) {
        this.postResponseMessage = this.customErrorMessges(error.response.data.codes)
        this.licenceMessage = 'error'
      }
      finally {
        this.isSubmitting = false;
      }
    },
    customErrorMessges(errorResponse) {
      const processErrorCode = ({ code, message }) => {
        if (code === "LICENSE_MANAGER_CREATE_ERROR") {
          return message;
        } else if (code === "SICHERN_PEOPLE_ABSENCE_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST") {
          return this.$t(`message.errorReference.${code}`);
        } else if (code === "SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST") {
          if (this.$t(`message.errorReference.${code}_${message}`)) {
            return this.$t(`message.errorReference.${code}_${message}`);
          }
          return this.$t(`message.errorReference.${code}`);
        } else if (/^SICHERN_PEOPLE_[A-Z_]+$/.test(code)) {
          const keyWithMessage = `message.errorReference.${code}_${message}`;
          const translatedWithMessage = this.$t(keyWithMessage);
          if (translatedWithMessage !== keyWithMessage) {
            return translatedWithMessage;
          }
          return this.$t(`message.errorReference.${code}`);
        } else {
          return this.$t(`message.errorReference.${code}`);
        }
      };
      return errorResponse.map(processErrorCode)[0];
    },
    convertToDate(dateString) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month}-${day}`;
    },

  },
  watch: {
    async search(val) {
      if (val.length > 2) {
        if (this.isLoading) return;
        this.isLoading = true;
        this.salaryPaymentAdvance = false
        this.allowsSalaryPaymentAdvance = false
        try {
          const res = await this.manager.getTeamUsers(val);
          const entries = res.data.data;
          const results = [];
          for (let i = 0; i < entries.length; i++) {
            if (entries[i].id !== this.myId) {
              results.push(entries[i]);
            }
          }
          this.entries = results;
        } catch (err) {
          // Handle error if needed
        } finally {
          this.isLoading = false;
        }
      }
    }
  },
}
</script>

<style scoped>
.bg-certs-info {
  background: #def3ff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #5b9cc2;
}

.bg-certs-warning {
  background: #d38f1149 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #D39011;
}

.bg-certs-error {
  background: #ffe2de 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #ffe2de;
}

.bg-certs-info>p {
  color: #017eec !important;
  opacity: 1 !important;
}

.bg-certs-error>p {
  color: #ec1101 !important;
  opacity: 1 !important;
}

.bg-certs-warning>p {
  color: #ec8e01 !important;
  opacity: 1 !important;
}

.info-button {
  background: #def3ff 0% 0% no-repeat padding-box !important;
  opacity: 1;
}

.info-icon {
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem;
  max-width: 40px;
}

.zt-icon-info {
  color: #def3ff;
  background: #017eec;
}

.zt-icon-exclamation-circle-solid {
  font-size: x-large;
  color: red;
}

.warning-icon {
  color: #def3ff;
  background: #eca101;
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem !important;
}

.error-icon {
  color: #def3ff;
  background: #ec1101;
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem;
}

.shadowcustom {
  min-height: 48px;
  padding-top: 10px;
  padding-bottom: 12px;
  -webkit-box-shadow: 0px 5px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 5px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}

::v-deep .shadowcustom>.vc-py-2 {
  border-bottom: 0px solid !important;
}
</style>